module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-block",
    class: _vm.position + ' ' + _vm.customClass
  }, [_c('div', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.headline)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _vm._t("text")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cd5cc2c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/title.vue
// module id = 930
// module chunks = 0